// extracted by mini-css-extract-plugin
export default {"container":"AttachmentImage_container__hlxsM","image":"AttachmentImage_image__t9YNG","deleteIcon":"AttachmentImage_deleteIcon__Gkebj"};